import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Box } from "@mui/material";
import CardMembership from "../../components/CardMembership/CardMembership";

const ModalMembreshipRecommended = ({
  open,
  setOpen,
  recomendedMembreship,
}) => {
  const [selected, setSelected] = useState(recomendedMembreship ?? 2);
  // console.log("Membresia recomendada, Modal", recomendedMembreship);
  const onClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      maxWidth="xs"
      fullWidth
      // Estas son las propiedades clave para el auto-ajuste de altura
      fullScreen={false}
      scroll="paper"
    >
      <DialogTitle>Membresía Recomendada</DialogTitle>
      <DialogContent dividers style={{ padding: "20px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <CardMembership
            membership={recomendedMembreship}
            selected={recomendedMembreship?._id === selected}
            setSelected={setSelected}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalMembreshipRecommended;
